import { Component, Input, OnInit } from '@angular/core'
import { FormControl, FormGroup, FormArray, FormBuilder } from '@angular/forms'
import { AuthorizeService } from '../../service/authorize.service'

@Component({
  selector: 'app-crm-continue-action',
  templateUrl: './crm-continue-action.component.html',
  styleUrls: ['./crm-continue-action.component.scss']
})
export class CrmContinueActionComponent implements OnInit {
  continueActions: Array<Object> = []
  disableTextArea: Boolean = false

  continueActionFormGroup: FormGroup = new FormGroup({})

  constructor(
    private fb: FormBuilder,
    private authorization: AuthorizeService
  ) {}

  get actionFormGroupArray(): FormArray {
    return this.continueActionFormGroup.get('actionFormGroupArray') as FormArray
  }

  get hasContinueAction(): Boolean {
    return this.actionFormGroupArray.length > 0
  }

  ngOnInit() {
    this.continueActionFormGroup = this.fb.group({
      actionFormGroupArray: this.fb.array([])
    })
  }

  async initial() {
    const setAttendanceArray = new FormArray([])
    this.continueActions.forEach(element => {
      setAttendanceArray.push(
        new FormGroup({
          action: new FormControl({
            value: element['action'],
            disabled: this.getDisableContinueActionBox(element)
          }),
          seq: new FormControl(element['seq'])
        })
      )
    })
    this.continueActionFormGroup.setControl(
      'actionFormGroupArray',
      setAttendanceArray
    )
  }

  getDisableContinueActionBox(element): Boolean {
    if (this.disableTextArea) {
      return true
    }
    return this.authorization.getUserId() !== element['employeeId']
  }

  getAssigneeName(id) {
    const assigneeInfo = this.continueActions[id]
    return assigneeInfo['firstNameThai'] + ' ' + assigneeInfo['lastNameThai']
  }

  getEditTimestamp(id) {
    const assigneeInfo = this.continueActions[id]
    return assigneeInfo['lastUpdateDate']
  }

  disableFormControlIfNotPermitted() {
    this.continueActionFormGroup.disable()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/crm-continue-action/crm-continue-action.component.ts